module.exports = __webpack_public_path__ + "static/media/xueyuan1.63d91678.jpg";